import api from './api';

export interface Integration {
  kind: string;
  configured: boolean;
}

export const integrationsService = {
  async list(): Promise<Integration[]> {
    const response = await api.get<{ data: Integration[] }>(
      '/config/integrations'
    );
    return response.data.data;
  },
  async setValue(kind: string, value: string): Promise<Integration> {
    const response = await api.put<Integration>(
      `/config/integrations/${kind}`,
      { value }
    );
    return response.data;
  },
  async remove(kind: string): Promise<void> {
    await api.delete(`/config/integrations/${kind}`);
  },
  async googleAuthUrl(): Promise<string> {
    const response = await api.get<{ authUrl: string }>(
      '/oauth/google/authorize'
    );
    return response.data.authUrl;
  },
};
